import angular from "angular";

export default function ChecklistTemplateRowCtrl() {
    var vm = this;
}
